module.exports = __webpack_public_path__ + "img/onboarding-footer-dark.f531c18e.svg";